import React, { useEffect } from 'react'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { mapData } from '../../../../product/common/components'
import './CustomSearch.css'
import { useTranslation } from 'react-i18next'
const CustomSearch = (props) => {
    const searchInfo = props.searchInfo
    const formik = props.formik
    const { t } = useTranslation()
    let condition = false
    if (searchInfo.length) {
        condition = true
    } else if (searchInfo.data) {
        if (searchInfo.data.length) {
            condition = true
        }
    }

    const handleSubmit = (e) => {
        formik.values.page = 1
        formik.handleSubmit(e)
    }
    return (
        <>
            {condition ? (
                <div className="commActBox d-flex justify-content-between align-items-center sac-search-wrapper">
                    <div className="w-100">
                        <form
                            onSubmit={handleSubmit}
                            className="row flex-wrap d-flex justify-content-start align-items-center"
                        >
                            {mapData(searchInfo)}
                            <div className="col-auto ml-auto btnSearch">
                                <PrimaryButton
                                    id="searchInfo_submit"
                                    label={t('search')?.toUpperCase()}
                                    type="submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default CustomSearch
